<script lang="ts" setup>
import type { AuctionCar } from '@autobid/ui/types/Car'
import { useShortPlz } from '@autobid/ui/composables/car/useShortPlz'
import { computed } from 'vue'

interface Props {
  car: AuctionCar
}

const props = defineProps<Props>()

const { shortPlz } = useShortPlz(computed(() => props.car))
</script>

<template>
  <p>
    {{ shortPlz }}

    <Icon
      v-if="car.additionalInformation?.itemLocationCountry?.isoCode"
      mode="svg"
      :name="`flagpack:${car.additionalInformation.itemLocationCountry.isoCode.toLowerCase()}`"
      class="h-6 w-9"
    />
  </p>
</template>
